export const WYSIWIG_CLASS_NAMES = {
  toolbarClassName: 'Wysiwyg-toolbarClassName',
  wrapperClassName: 'Wysiwyg-wrapperClassName',
  editorClassName: 'Wysiwyg-editorClassName',
  blockTypeClassName: 'Wysiwyg-blockTypeClassName',
  fontSizeClassName: 'Wysiwyg-fontSizeClassName',
  fontFamilyClassName: 'Wysiwyg-fontFamilyClassName'
}
